import { ActionVo } from '@/utils/actionsHandler'

/** 与 scenceCard.doIsjoined 展开后的分级调光 MsgType 一致 */
const STEP_DIM_MSG_TYPES = ['0x03D80000', '0x03DA0000', '0x03840000', '0x03DA00000x03840000'];
const STEP_CCT_MSG_TYPES = ['0x03880000'];

function isUnifiedMsgTypeMatch(val0, modelMsgType) {
  if (!modelMsgType) return false;
  if (val0 instanceof Array) {
    if (val0.indexOf(modelMsgType) !== -1) return true;
    if (STEP_DIM_MSG_TYPES.includes(modelMsgType) && val0.some((t) => STEP_DIM_MSG_TYPES.includes(t))) {
      return true;
    }
    if (STEP_CCT_MSG_TYPES.includes(modelMsgType) && val0.some((t) => STEP_CCT_MSG_TYPES.includes(t))) {
      return true;
    }
    return false;
  }
  if (typeof val0 === 'string') {
    if (val0 === modelMsgType) return true;
    if (val0 === '0x03DA00000x03840000' && STEP_DIM_MSG_TYPES.includes(modelMsgType)) return true;
    return modelMsgType.indexOf(val0) !== -1;
  }
  return false;
}

export function fillCheckeddata (val, checkeddata) {
  let _item
  if (checkeddata != null && checkeddata.length > 0) {
    checkeddata.forEach(item => {
      if (item.ischeck == true && item.ActionList != null && item.ActionList.length > 0) {
        item.ActionList.forEach(model => {
          if (val[0] instanceof Array && isUnifiedMsgTypeMatch(val[0], model.MsgType)) {
            // 仅使能时做互斥校验；禁能必须同步到设备
            if (val[1] === true) {
              const {
                result,
              } = ActionVo.isConflictAction('Scene', model.MsgType, item.ActionList);
              if (result === false) return;
            }
            model.ischeck = val[1]
          } else {
            _item = model && model.Values
            if (_item != null && _item.length > 0) {
              _item.forEach(itemObj => {
                if (itemObj != null && typeof itemObj.Type === 'string' &&
                  (
                    val[0] instanceof Array && val[0].find((_val) => { return itemObj.Type.indexOf(_val) != -1 }) != null ||
                    typeof val[0] === 'string' && itemObj.Type.indexOf(val[0]) != -1
                  )) {
                  model.ischeck = val[1]
                }
              })
            }
          }
        })
      }
    })
  }
}

const OrderMap = {
  '0x03110000': 900, // 开关
  '0x03130000': 800, // 亮度
  '0x031B0000': 700, // 色温
  '0x03840000': 600, // 分级亮度
  '0x03880000': 500 // 分级色温
}
const OrderMapNarrowScreen = {
  '0x03110000': 900,
  '0x03130000': 800,
  '0x031B0000': 600,
  '0x03840000': 700,
  '0x03880000': 500
}
export function addResizeEvent (self) {
  const handler = () => {
    const documentWidth = self.$store.state.appDocumentWidth
    const _documentWidth = document.documentElement.scrollWidth
    if (_documentWidth > 1366 && documentWidth > 1366 || _documentWidth < 1366 && documentWidth < 1366 || _documentWidth === documentWidth) return
    self.$store.commit('setAppDocumentWidth', _documentWidth)
  }
  window.addEventListener('resize', handler)
  self.$emit('hook:beforeDestroy', () => {
    window.removeEventListener('resize', handler)
  })
}

export function getFillOrderFn (width) {
  return (key, Con) => {
    const map = Con || width > 1366 ? OrderMap : OrderMapNarrowScreen
    return map[key]
  }
}
